// Карточка направления (макет «Главная · развилка»; в Mini App — доска «Mini App · первый
// экран», версия 67): картинка с меткой, название, строка о направлении и цена «от …». На сайте
// карточка — ссылка на витрину, в Mini App — выбор, а действие — нижняя кнопка Telegram.
import type { ReactNode } from "react";
import type { Catalog } from "../api/types";
import type { Door } from "../site/directionDoors";
import { directionClass } from "../site/directionPaths";
import { formatRub, lowestPrintPrice } from "../site/prices";
import { SIZES_FULL, picture, type PicturePriority } from "../site/pictures";
import { Icon } from "./icons";
import styles from "./DirectionDoor.module.css";

// Внутренность карточки. corner — значок в углу картинки, footerEnd — справа от цены.
export function DoorInside({
  door,
  catalog,
  corner,
  footerEnd,
  priority = "eager",
}: {
  door: Door;
  catalog: Catalog | undefined;
  corner?: ReactNode;
  footerEnd?: ReactNode;
  priority?: PicturePriority;
}) {
  const lowest = catalog === undefined ? null : lowestPrintPrice(catalog, door.direction);
  return (
    <>
      <span className={styles.doorImage}>
        <img {...picture(door.image, SIZES_FULL, priority)} alt={door.imageAlt} style={{ objectPosition: door.imagePosition }} />
        <span className={styles.doorTag}>{door.tag}</span>
        {corner}
      </span>
      <span className={styles.doorBody}>
        <span className={styles.doorTitle}>{door.title}</span>
        {door.size !== undefined && <span className="mono muted">{door.size}</span>}
        <span className={styles.doorText}>{door.text}</span>
        <span className={styles.doorFooter}>
          <span className={styles.doorPrice}>{lowest !== null ? `от ${formatRub(lowest)}` : ""}</span>
          {footerEnd}
        </span>
      </span>
    </>
  );
}

// Карточка-выбор в Mini App: у выбранной — рамка цвета направления и галочка в углу.
export function DoorChoice({
  door,
  catalog,
  chosen,
  onChoose,
}: {
  door: Door;
  catalog: Catalog | undefined;
  chosen: boolean;
  onChoose: () => void;
}) {
  return (
    <button
      type="button"
      role="radio"
      aria-checked={chosen}
      className={`${styles.door} ${styles.choice} ${directionClass(door.direction)}`}
      onClick={onChoose}
    >
      <DoorInside
        door={door}
        catalog={catalog}
        corner={
          chosen && (
            <span className={styles.tick}>
              <Icon name="check" size={14} strokeWidth={3} />
            </span>
          )
        }
      />
    </button>
  );
}
